.region {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 80;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: min(400px, calc(100vw - 32px));
  pointer-events: none;
}

.toast {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 8px 14px 16px;
  border: 1px solid var(--border-card);
  border-left-width: 4px;
  border-radius: var(--radius-md);
  background: var(--white);
  box-shadow: var(--shadow-menu);
  pointer-events: auto;
  animation: rise var(--dur-base) var(--ease-out);
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
}

.done {
  border-left-color: var(--status-done-ink);
}

.info {
  border-left-color: var(--brand-cyan);
}

.problem {
  border-left-color: var(--status-problem-ink);
}

.icon {
  display: grid;
  flex: none;
  place-items: center;
  width: 28px;
  height: 28px;
  margin-top: 2px;
  border-radius: 50%;
}

.done .icon {
  background: var(--status-done-bg);
  color: var(--status-done-ink);
}

.info .icon {
  background: var(--status-info-bg);
  color: var(--status-info-ink);
}

.problem .icon {
  background: var(--status-problem-bg);
  color: var(--status-problem-ink);
}

.text {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  padding-top: 4px;
}

.title {
  color: var(--text-heading);
  font-size: 14px;
  font-weight: var(--fw-bold);
}

.body {
  color: var(--text-secondary);
  font-size: 13px;
  line-height: 1.5;
}

.close {
  display: grid;
  flex: none;
  place-items: center;
  width: 44px;
  height: 44px;
  margin-top: -8px;
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
}

.close[data-hovered],
.close[data-focus-visible] {
  background: var(--gray-75);
  color: var(--brand-navy);
}
